import React, { useContext } from "react";
import classes from "./DoctorCard.module.css";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import DeptCapitalise from "../../Decapitalize";
import { NavigationContext } from "../../../App";
import { MUVATTUPUZHA_BRANCH_ID } from "../../../utils/constants";

const todaysDateFetcher = () => {
  const dateValue = new Date();
  const year = dateValue.getFullYear();
  const month = dateValue.getMonth() + 1;
  const final = month > 9 ? month : "0" + month;
  const day = dateValue.getDate();
  const dayFinal = day < 10 ? "0" + day : day;
  return dayFinal + "/" + final + "/" + year;
};

const DoctorCard = ({
  data,
  checkIsDisable = false, //to check when data comes from widgets and doctors page
  className,
  date = todaysDateFetcher(),
  saveState,
  branchHisId,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { homeApis } = useSelector((state) => state.widget);
  const sessionStore = location?.pathname?.includes("/branch")
    ? "branches"
    : location?.pathname?.includes("online-consultation")
      ? "online-consultation"
      : "home";

  const { setIsBackNavigation } = useContext(NavigationContext);
  const defaultBranchHisId = homeApis?.branches?.find((branch) => {
    const name = branch?.name?.toLowerCase?.() || "";
    const branchLocation = branch?.location?.toLowerCase?.() || "";
    return (
      branch?.hisId === MUVATTUPUZHA_BRANCH_ID ||
      name.includes("muvattupuzha") ||
      branchLocation.includes("muvattupuzha")
    );
  })?.hisId;
  const doctorBranchHisId =
    Array.isArray(data?.branches) && data.branches.length > 0
      ? data.branches[0]?.hisId
      : undefined;
  const resolvedBranchHisId =
    branchHisId || doctorBranchHisId || defaultBranchHisId;

  const formatName = (name) => {
    const first = name
      .toLowerCase()
      .split(/[ .]/)
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");

    // const second = first.substring(0, 2) + "." + first.substring(2);
    // const second = first.substring(0, 2) + "." + first.substring(2);

    return first;
  };

  return (
    <div
      className={`${classes.cardContainer} ${className}`}
      id={sessionStore}
      onClick={() => {
        if (saveState) {
          navigate(
            data?._id
              ? `/doctor-booking-detail/${data._id}?date=${date}&branchHisId=${resolvedBranchHisId}`
              : `/book-doctor/${data.doctor_id}?date=${date}&branchHisId=${resolvedBranchHisId}`,
          );
          saveState();
          return;
        }
        if (!(!checkIsDisable && data?.is_outofstation)) {
          //to restrict to detail since out of station
          const yPos = window.scrollY;
          sessionStorage.setItem("scrollTargetY", yPos.toString());
          sessionStorage.setItem("scrollOrigin", sessionStore); // or "branch" depending on the page
          setIsBackNavigation(true);
          navigate(
            data?._id
              ? `/doctor-booking-detail/${data._id}?date=${date}&branchHisId=${resolvedBranchHisId}`
              : `/book-doctor/${data.doctor_id}?date=${date}&branchHisId=${resolvedBranchHisId}`,
          );
        }
      }}
    >
      <img
        // src={data?.image}
        src={
          data?.image && data?.image != "test"
            ? data?.image?.startsWith("https://")
              ? data?.image
              : `data:image/png;base64, ${data?.image}`
            : `/img/designs/doc-pic.svg`
        }
        alt="profile"
        className={classes.profilePic2}
      />
      <h3 className={classes.docName}>{formatName(data?.doctor_name)}</h3>
      <h4 className={classes.deptName}>
        {DeptCapitalise(data?.department_name)}
      </h4>
      {data?.qualification && (
        <h5 className={classes.qualification} title={data?.qualification}>
          {data?.qualification}
        </h5>
      )}
      {!data?.qualification && (
        <h5
          className={`${classes.qualification} ${classes.qualificationHide}`}
          title={data?.qualification}
        >
          Qualification
        </h5>
      )}
      <button
        onClick={(e) => {
          e.stopPropagation();
          const yPos = window.scrollY;
          sessionStorage.setItem("scrollTargetY", yPos.toString());
          sessionStorage.setItem("scrollOrigin", sessionStore); // or "branch" depending on the page
          setIsBackNavigation(true);
          navigate(
            data?._id
              ? `/doctor-booking-detail/${data._id}?date=${date}&branchHisId=${resolvedBranchHisId}`
              : `/book-doctor/${data.doctor_id}?date=${date}&branchHisId=${resolvedBranchHisId}`,
          );
        }}
        className={`${classes.exploreButton} primaryHover`}
        disabled={
          (checkIsDisable && !data?.hisId) ||
          (!checkIsDisable && data?.is_outofstation)
        }
      >
        {!checkIsDisable && data?.is_outofstation
          ? "Not Available"
          : "Book Appointment"}
      </button>
    </div>
  );
};

export default DoctorCard;
